import axios from "axios";
import { useMsal } from "@azure/msal-react";
import { fetchToken } from "./fetchTokenService";
import { loginRequest } from "../auth/authConfig";
import { getConsumerKey } from "./maerskApiTokenService";

const API_BASE_URL = process.env.REACT_APP_FREE_TEXT_API_ENDPOINT || process.env.REACT_APP_POSTMORTEM_API_ENDPOINT;

export const TranscriptService = () => {
  const { instance, accounts } = useMsal();

  const getAuthHeaders = async () => {
    const tokenResponse = await fetchToken(instance, loginRequest, accounts);
    return {
      Authorization: `Bearer ${tokenResponse.idToken}`,
      "consumer-key": getConsumerKey(),
    };
  };
  const uploadTranscript = async (postMortemId, incidentId, file, uploadedBy) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const authHeaders = await getAuthHeaders();
      const response = await axios.post(
        `${API_BASE_URL}/api/postmortem-enhancements/${postMortemId}/transcript/upload`,
        formData,
        {
          headers: { ...authHeaders, 'Content-Type': 'multipart/form-data' },
          params: { incidentId, uploadedBy },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error uploading transcript:", error);
      throw error;
    }
  };

  const checkTranscriptExists = async (postMortemId) => {
    try {
      const authHeaders = await getAuthHeaders();
      const response = await axios.get(
        `${API_BASE_URL}/api/postmortem-enhancements/${postMortemId}/transcript/exists`,
        { headers: authHeaders }
      );
      return response.data;
    } catch (error) {
      console.error("Error checking transcript existence:", error);
      throw error;
    }
  };

  const getTranscriptMetadata = async (postMortemId) => {
    try {
      const authHeaders = await getAuthHeaders();
      const response = await axios.get(
        `${API_BASE_URL}/api/postmortem-enhancements/${postMortemId}/transcript/metadata`,
        { headers: authHeaders }
      );
      return response.data;
    } catch (error) {
      console.error("Error getting transcript metadata:", error);
      throw error;
    }
  };

  const deleteTranscript = async (postMortemId, fileName) => {
    try {
      const authHeaders = await getAuthHeaders();
      const response = await axios.delete(
        `${API_BASE_URL}/api/postmortem-enhancements/${postMortemId}/transcript/${encodeURIComponent(fileName)}`,
        { headers: authHeaders }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting transcript:", error);
      throw error;
    }
  };

  // â”€â”€â”€ 24 Hour PIR Transcript â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

  const uploadPirTranscript = async (postMortemId, incidentId, file, uploadedBy) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const authHeaders = await getAuthHeaders();
      const response = await axios.post(
        `${API_BASE_URL}/api/postmortem-enhancements/${postMortemId}/pir-transcript/upload`,
        formData,
        {
          headers: { ...authHeaders, 'Content-Type': 'multipart/form-data' },
          params: { incidentId, uploadedBy },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error uploading PIR transcript:", error);
      throw error;
    }
  };

  const checkPirTranscriptExists = async (postMortemId) => {
    try {
      const authHeaders = await getAuthHeaders();
      const response = await axios.get(
        `${API_BASE_URL}/api/postmortem-enhancements/${postMortemId}/pir-transcript/exists`,
        { headers: authHeaders }
      );
      return response.data;
    } catch (error) {
      console.error("Error checking PIR transcript existence:", error);
      throw error;
    }
  };

  const deletePirTranscript = async (postMortemId, fileName) => {
    try {
      const authHeaders = await getAuthHeaders();
      const response = await axios.delete(
        `${API_BASE_URL}/api/postmortem-enhancements/${postMortemId}/pir-transcript/${encodeURIComponent(fileName)}`,
        { headers: authHeaders }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting PIR transcript:", error);
      throw error;
    }
  };

  // â”€â”€â”€ PLATFORMREVIEW Transcript â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

  const uploadSreReviewTranscript = async (postMortemId, incidentId, file, uploadedBy) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const authHeaders = await getAuthHeaders();
      const response = await axios.post(
        `${API_BASE_URL}/api/postmortem-enhancements/${postMortemId}/sre-review-transcript/upload`,
        formData,
        {
          headers: { ...authHeaders, 'Content-Type': 'multipart/form-data' },
          params: { incidentId, uploadedBy },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error uploading PLATFORM REVIEW transcript:", error);
      throw error;
    }
  };

  const checkSreReviewTranscriptExists = async (postMortemId) => {
    try {
      const authHeaders = await getAuthHeaders();
      const response = await axios.get(
        `${API_BASE_URL}/api/postmortem-enhancements/${postMortemId}/sre-review-transcript/exists`,
        { headers: authHeaders }
      );
      return response.data;
    } catch (error) {
      console.error("Error checking PLATFORMREVIEW transcript existence:", error);
      throw error;
    }
  };

  const deleteSreReviewTranscript = async (postMortemId, fileName) => {
    try {
      const authHeaders = await getAuthHeaders();
      const response = await axios.delete(
        `${API_BASE_URL}/api/postmortem-enhancements/${postMortemId}/sre-review-transcript/${encodeURIComponent(fileName)}`,
        { headers: authHeaders }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting PLATFORMREVIEW transcript:", error);
      throw error;
    }
  };

  return {
    uploadTranscript,
    checkTranscriptExists,
    getTranscriptMetadata,
    deleteTranscript,
    uploadPirTranscript,
    checkPirTranscriptExists,
    deletePirTranscript,
    uploadSreReviewTranscript,
    checkSreReviewTranscriptExists,
    deleteSreReviewTranscript,
  };
};

